<template>
    <div class="container fluid  mt-5">
        <div class="bg-danger p-3 text-center baseline">
            <span class="display-4"> Obrigado por participar!</span>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

body, 
html,* {
    margin: 0;
    padding: 0;
}

</style>